import script from "./TimetableSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimetableSearch.vue?vue&type=script&setup=true&lang=ts"

import "./TimetableSearch.vue?vue&type=style&index=0&id=663486a1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-663486a1"]])

export default __exports__